import { environment as hmlEnvironment } from './hml.environments';
import { environment as localEnvironment } from './local.environments';
import { environment as prdEnvironment } from './prd.environments';
import { environment as tstEnvironment } from './tst.environments';

export class EnvConfigClass {
  static getEnvConfig() {
    // A variável profile é carregada no momento de execução pelo window.profile ou pelo arquivo env.*.json
    let profile = '';
    // @ts-ignore
    if (typeof window !== 'undefined' && window.envConfig && window.envConfig.profile) {
      // @ts-ignore
      profile = window.envConfig.profile;
    // @ts-ignore
    } else if (typeof window !== 'undefined' && window.profile) {
      // @ts-ignore
      profile = window.profile;
    }
    profile = (profile || '').toUpperCase();
    switch (profile) {
      case 'PRD':
        return prdEnvironment;
      case 'HML':
        return hmlEnvironment;
      case 'TST':
        return tstEnvironment;
      default:
        return localEnvironment;
    }
  }
}

export const EnvConfig = EnvConfigClass.getEnvConfig();
